import { render, staticRenderFns } from "./PartyWorkDetails.vue?vue&type=template&id=b272bdc6&scoped=true&"
import script from "./PartyWorkDetails.vue?vue&type=script&lang=js&"
export * from "./PartyWorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./PartyWorkDetails.vue?vue&type=style&index=0&id=b272bdc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b272bdc6",
  null
  
)

export default component.exports